<common-internal-header></common-internal-header>
<main role="main" class="container">
  <router-outlet></router-outlet>
</main>